import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotFoundService {

  showNotFound = false;
  constructor() { }
}
